import { TreeGroupBy, TreeYearFilter } from 'utils/FarmUtils';

import { RootState } from '../Store';

export const getTreeYearFilter = (state: RootState): TreeYearFilter =>
  state.farmReducer.treeYearFilter;

export const getSidebarCollapsed = (state: RootState): boolean =>
  state.farmReducer.sidebarCollapsed;

export const getTreeGroupBy = (state: RootState): TreeGroupBy =>
  state.farmReducer.treeGroupBy;

export const getSelectedFarmId = (state: RootState): string | null =>
  state.farmReducer.selectedFarmId;

export const getSelectedPaddockId = (state: RootState): string | null =>
  state.farmReducer.selectedPaddockId;

export const getActiveTreeNodeKey = (state: RootState): string | null =>
  state.farmReducer.activeTreeNodeKey;
